import React from 'react';

/**
 * Wraps a button-like child with a diagonal light beam that sweeps across on
 * hover, plus an animated conic-gradient glow border. Renders inline so it
 * inherits the child's radius (pass rounded-full / rounded-md / etc. on the
 * child). Non-interactive itself.
 */
const STYLE_ID = 'esg-beam-btn-style';
const ensureStyle = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = `
    @keyframes esg-beam-sweep {
      0%   { transform: translateX(-120%) skewX(-20deg); }
      100% { transform: translateX(220%)  skewX(-20deg); }
    }
    @keyframes esg-beam-glow-spin {
      to { transform: rotate(360deg); }
    }
    .esg-beam-wrap { position: relative; display: inline-block; isolation: isolate; }
    .esg-beam-wrap::before {
      content: '';
      position: absolute; inset: -2px;
      border-radius: inherit;
      background: conic-gradient(from 0deg, transparent 0%, rgba(59,130,246,0.9) 25%, rgba(16,185,129,0.9) 50%, transparent 65%, transparent 100%);
      opacity: 0;
      transition: opacity .3s ease;
      z-index: -1;
      animation: esg-beam-glow-spin 3.5s linear infinite;
      filter: blur(6px);
    }
    .esg-beam-wrap:hover::before { opacity: .75; }
    .esg-beam-sweep {
      position: absolute; inset: 0;
      overflow: hidden;
      border-radius: inherit;
      pointer-events: none;
    }
    .esg-beam-sweep::after {
      content: '';
      position: absolute;
      top: 0; left: 0;
      width: 40%; height: 100%;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.55) 50%, transparent 100%);
      transform: translateX(-120%) skewX(-20deg);
      opacity: 0;
      transition: opacity .2s ease;
    }
    .esg-beam-wrap:hover .esg-beam-sweep::after {
      opacity: 1;
      animation: esg-beam-sweep 1s ease-out forwards;
    }
    @media (prefers-reduced-motion: reduce) {
      .esg-beam-wrap::before { animation: none; }
      .esg-beam-wrap:hover .esg-beam-sweep::after { animation: none; opacity: 0; }
    }
  `;
  document.head.appendChild(s);
};

const BeamButton = ({ children, className = '', style = {} }) => {
  ensureStyle();
  return (
    <span className={`esg-beam-wrap ${className}`} style={style}>
      {children}
      <span className="esg-beam-sweep" aria-hidden="true" />
    </span>
  );
};

export default BeamButton;
